// extracted by mini-css-extract-plugin
export default {"buttons":"show_buttons__q-51l","table":"show_table__HdWGv"};